<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M12,24C5.383,24,0,18.617,0,12c0-3.174,1.232-6.167,3.469-8.43c0.012-0.017,0.027-0.036,0.046-0.055
		c0.014-0.014,0.033-0.029,0.052-0.043C5.831,1.232,8.824,0,12,0c6.617,0,12,5.383,12,12c0,3.174-1.231,6.167-3.468,8.43
		c-0.012,0.017-0.027,0.036-0.047,0.055c-0.014,0.014-0.033,0.03-0.052,0.043C18.169,22.768,15.176,24,12,24z M4.069,5.13
		C2.41,7.042,1.5,9.466,1.5,12c0,5.79,4.71,10.5,10.5,10.5c2.534,0,4.958-0.909,6.87-2.569L4.069,5.13z M19.931,18.87
		c1.66-1.912,2.569-4.336,2.569-6.87c0-5.79-4.71-10.5-10.5-10.5c-2.534,0-4.958,0.91-6.87,2.569L19.931,18.87z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'road-sign-banned',
    },
    name: {
      type: String,
      required: false,
      default: 'RoadSignBanned',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>